import CollectionDeleteModalComponent from "./CollectionDeleteModalComponent";

export default CollectionDeleteModalComponent;